// src/App.js
import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
  Routes,
  Route,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import Header from './Header';
import TabDividerApp from './TabDividerApp';
import Footer from './Footer';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import Disclaimer from './pages/Disclaimer';
import GDPRCompliance from './pages/GDPRCompliance';
import FAQ from './pages/FAQ';
// Ensure these paths are correct for your project structure
import BlogListingPage from './Blog/BlogListingPage';
import BlogPostPage from './Blog/BlogPostPage';

// --- COMPREHENSIVE CURRENCIES CONFIGURATION ---
const CURRENCIES = {
    USD: { symbol: '$', name: 'US Dollar' },
    EUR: { symbol: '€', name: 'Euro' },
    JPY: { symbol: '¥', name: 'Japanese Yen' },
    GBP: { symbol: '£', name: 'British Pound Sterling' },
    AUD: { symbol: 'A$', name: 'Australian Dollar' },
    CAD: { symbol: 'C$', name: 'Canadian Dollar' },
    CHF: { symbol: 'CHF', name: 'Swiss Franc' },
    CNY: { symbol: '¥', name: 'Chinese Yuan Renminbi' },
    SEK: { symbol: 'kr', name: 'Swedish Krona' },
    NZD: { symbol: 'NZ$', name: 'New Zealand Dollar' },
    MXN: { symbol: '$', name: 'Mexican Peso' },
    SGD: { symbol: 'S$', name: 'Singapore Dollar' },
    HKD: { symbol: 'HK$', name: 'Hong Kong Dollar' },
    NOK: { symbol: 'kr', name: 'Norwegian Krone' },
    KRW: { symbol: '₩', name: 'South Korean Won' },
    TRY: { symbol: '₺', name: 'Turkish Lira' },
    RUB: { symbol: '₽', name: 'Russian Ruble' },
    INR: { symbol: '₹', name: 'Indian Rupee' },
    BRL: { symbol: 'R$', name: 'Brazilian Real' },
    ZAR: { symbol: 'R', name: 'South African Rand' },
    AED: { symbol: 'د.إ', name: 'UAE Dirham' },
    AFN: { symbol: '؋', name: 'Afghan Afghani' },
    ALL: { symbol: 'L', name: 'Albanian Lek' },
    AMD: { symbol: '֏', name: 'Armenian Dram' },
    ANG: { symbol: 'ƒ', name: 'Netherlands Antillean Guilder' },
    AOA: { symbol: 'Kz', name: 'Angolan Kwanza' },
    ARS: { symbol: '$', name: 'Argentine Peso' },
    AWG: { symbol: 'ƒ', name: 'Aruban Florin' },
    AZN: { symbol: '₼', name: 'Azerbaijani Manat' },
    BAM: { symbol: 'KM', name: 'Bosnia-Herzegovina Convertible Mark' },
    BBD: { symbol: '$', name: 'Barbadian Dollar' },
    BDT: { symbol: '৳', name: 'Bangladeshi Taka' },
    BGN: { symbol: 'лв', name: 'Bulgarian Lev' },
    BHD: { symbol: '.د.ب', name: 'Bahraini Dinar' },
    BIF: { symbol: 'FBu', name: 'Burundian Franc' },
    BMD: { symbol: '$', name: 'Bermudan Dollar' },
    BND: { symbol: '$', name: 'Brunei Dollar' },
    BOB: { symbol: 'Bs.', name: 'Bolivian Boliviano' },
    BSD: { symbol: '$', name: 'Bahamian Dollar' },
    BTN: { symbol: 'Nu.', name: 'Bhutanese Ngultrum' },
    BWP: { symbol: 'P', name: 'Botswanan Pula' },
    BYN: { symbol: 'Br', name: 'Belarusian Ruble' },
    BZD: { symbol: 'BZ$', name: 'Belize Dollar' },
    CDF: { symbol: 'FC', name: 'Congolese Franc' },
    CLP: { symbol: '$', name: 'Chilean Peso' },
    COP: { symbol: '$', name: 'Colombian Peso' },
    CRC: { symbol: '₡', name: 'Costa Rican Colón' },
    CUP: { symbol: '$', name: 'Cuban Peso' },
    CVE: { symbol: 'Esc', name: 'Cape Verdean Escudo' },
    CZK: { symbol: 'Kč', name: 'Czech Koruna' },
    DJF: { symbol: 'Fdj', name: 'Djiboutian Franc' },
    DKK: { symbol: 'kr', name: 'Danish Krone' },
    DOP: { symbol: 'RD$', name: 'Dominican Peso' },
    DZD: { symbol: 'د.ج', name: 'Algerian Dinar' },
    EGP: { symbol: 'E£', name: 'Egyptian Pound' },
    ERN: { symbol: 'Nfk', name: 'Eritrean Nakfa' },
    ETB: { symbol: 'Br', name: 'Ethiopian Birr' },
    FJD: { symbol: '$', name: 'Fijian Dollar' },
    FKP: { symbol: '£', name: 'Falkland Islands Pound' },
    FOK: { symbol: 'kr', name: 'Faroese Króna' },
    GEL: { symbol: '₾', name: 'Georgian Lari' },
    GGP: { symbol: '£', name: 'Guernsey Pound' },
    GHS: { symbol: '₵', name: 'Ghanaian Cedi' },
    GIP: { symbol: '£', name: 'Gibraltar Pound' },
    GMD: { symbol: 'D', name: 'Gambian Dalasi' },
    GNF: { symbol: 'FG', name: 'Guinean Franc' },
    GTQ: { symbol: 'Q', name: 'Guatemalan Quetzal' },
    GYD: { symbol: '$', name: 'Guyanaese Dollar' },
    HNL: { symbol: 'L', name: 'Honduran Lempira' },
    HRK: { symbol: 'kn', name: 'Croatian Kuna' },
    HTG: { symbol: 'G', name: 'Haitian Gourde' },
    HUF: { symbol: 'Ft', name: 'Hungarian Forint' },
    IDR: { symbol: 'Rp', name: 'Indonesian Rupiah' },
    ILS: { symbol: '₪', name: 'Israeli New Shekel' },
    IMP: { symbol: '£', name: 'Isle of Man Pound' },
    IQD: { symbol: 'ع.د', name: 'Iraqi Dinar' },
    IRR: { symbol: '﷼', name: 'Iranian Rial' },
    ISK: { symbol: 'kr', name: 'Icelandic Króna' },
    JEP: { symbol: '£', name: 'Jersey Pound' },
    JMD: { symbol: 'J$', name: 'Jamaican Dollar' },
    JOD: { symbol: 'JD', name: 'Jordanian Dinar' },
    KES: { symbol: 'KSh', name: 'Kenyan Shilling' },
    KGS: { symbol: 'с', name: 'Kyrgystani Som' },
    KHR: { symbol: '៛', name: 'Cambodian Riel' },
    KID: { symbol: '$', name: 'Kiribati Dollar' },
    KMF: { symbol: 'CF', name: 'Comorian Franc' },
    KWD: { symbol: 'د.ك', name: 'Kuwaiti Dinar' },
    KYD: { symbol: '$', name: 'Cayman Islands Dollar' },
    KZT: { symbol: '₸', name: 'Kazakhstani Tenge' },
    LAK: { symbol: '₭', name: 'Laotian Kip' },
    LBP: { symbol: 'ل.ل', name: 'Lebanese Pound' },
    LKR: { symbol: 'Rs', name: 'Sri Lankan Rupee' },
    LRD: { symbol: '$', name: 'Liberian Dollar' },
    LSL: { symbol: 'L', name: 'Lesotho Loti' },
    LYD: { symbol: 'ل.د', name: 'Libyan Dinar' },
    MAD: { symbol: 'د.م.', name: 'Moroccan Dirham' },
    MDL: { symbol: 'L', name: 'Moldovan Leu' },
    MGA: { symbol: 'Ar', name: 'Malagasy Ariary' },
    MKD: { symbol: 'ден', name: 'Macedonian Denar' },
    MMK: { symbol: 'K', name: 'Myanmar Kyat' },
    MNT: { symbol: '₮', name: 'Mongolian Tugrik' },
    MOP: { symbol: 'P', name: 'Macanese Pataca' },
    MRU: { symbol: 'UM', name: 'Mauritanian Ouguiya' },
    MUR: { symbol: '₨', name: 'Mauritian Rupee' },
    MVR: { symbol: 'Rf', name: 'Maldivian Rufiyaa' },
    MWK: { symbol: 'MK', name: 'Malawian Kwacha' },
    MYR: { symbol: 'RM', name: 'Malaysian Ringgit' },
    MZN: { symbol: 'MT', name: 'Mozambican Metical' },
    NAD: { symbol: '$', name: 'Namibian Dollar' },
    NGN: { symbol: '₦', name: 'Nigerian Naira' },
    NIO: { symbol: 'C$', name: 'Nicaraguan Córdoba' },
    NPR: { symbol: '₨', name: 'Nepalese Rupee' },
    OMR: { symbol: 'ر.ع.', name: 'Omani Rial' },
    PAB: { symbol: 'B/.', name: 'Panamanian Balboa' },
    PEN: { symbol: 'S/', name: 'Peruvian Sol' },
    PGK: { symbol: 'K', name: 'Papua New Guinean Kina' },
    PHP: { symbol: '₱', name: 'Philippine Peso' },
    PKR: { symbol: '₨', name: 'Pakistani Rupee' },
    PLN: { symbol: 'zł', name: 'Polish Złoty' },
    PYG: { symbol: '₲', name: 'Paraguayan Guarani' },
    QAR: { symbol: 'ر.ق', name: 'Qatari Riyal' },
    RON: { symbol: 'lei', name: 'Romanian Leu' },
    RSD: { symbol: 'дин.', name: 'Serbian Dinar' },
    RWF: { symbol: 'RF', name: 'Rwandan Franc' },
    SAR: { symbol: 'ر.س', name: 'Saudi Riyal' },
    SBD: { symbol: '$', name: 'Solomon Islands Dollar' },
    SCR: { symbol: '₨', name: 'Seychellois Rupee' },
    SDG: { symbol: 'ج.س.', name: 'Sudanese Pound' },
    SHP: { symbol: '£', name: 'Saint Helena Pound' },
    SLE: { symbol: 'Le', name: 'Sierra Leonean Leone' }, // New Leone
    SLL: { symbol: 'Le', name: 'Sierra Leonean Leone (Old)' },
    SOS: { symbol: 'S', name: 'Somali Shilling' },
    SRD: { symbol: '$', name: 'Surinamese Dollar' },
    SSP: { symbol: '£', name: 'South Sudanese Pound' },
    STN: { symbol: 'Db', name: 'São Tomé & Príncipe Dobra' },
    SYP: { symbol: '£', name: 'Syrian Pound' },
    SZL: { symbol: 'L', name: 'Swazi Lilangeni' },
    THB: { symbol: '฿', name: 'Thai Baht' },
    TJS: { symbol: 'SM', name: 'Tajikistani Somoni' },
    TMT: { symbol: 'm', name: 'Turkmenistani Manat' },
    TND: { symbol: 'د.ت', name: 'Tunisian Dinar' },
    TOP: { symbol: 'T$', name: 'Tongan Paʻanga' },
    TTD: { symbol: 'TT$', name: 'Trinidad & Tobago Dollar' },
    TVD: { symbol: '$', name: 'Tuvaluan Dollar' },
    TWD: { symbol: 'NT$', name: 'New Taiwan Dollar' },
    TZS: { symbol: 'TSh', name: 'Tanzanian Shilling' },
    UAH: { symbol: '₴', name: 'Ukrainian Hryvnia' },
    UGX: { symbol: 'USh', name: 'Ugandan Shilling' },
    UYU: { symbol: '$U', name: 'Uruguayan Peso' },
    UZS: { symbol: 'soʻm', name: 'Uzbekistani Som' },
    VES: { symbol: 'Bs.S.', name: 'Venezuelan Bolívar Soberano' },
    VND: { symbol: '₫', name: 'Vietnamese Đồng' },
    VUV: { symbol: 'VT', name: 'Vanuatu Vatu' },
    WST: { symbol: 'T', name: 'Samoan Tala' },
    XAF: { symbol: 'FCFA', name: 'Central African CFA Franc' },
    XCD: { symbol: '$', name: 'East Caribbean Dollar' },
    XDR: { symbol: 'SDR', name: 'Special Drawing Rights (IMF)' },
    XOF: { symbol: 'F CFA', name: 'West African CFA Franc' },
    XPF: { symbol: '₣', name: 'CFP Franc (French Pacific Territories)' },
    YER: { symbol: '﷼', name: 'Yemeni Rial' },
    ZMW: { symbol: 'ZK', name: 'Zambian Kwacha' },
    ZWL: { symbol: '$', name: 'Zimbabwean Dollar' },
};

// --- COMPREHENSIVE REGIONS CONFIGURATION ---
const REGIONS = {
    US: { name: 'United States', taxLabel: 'Tax', serviceLabel: 'Service Charge/Tip' },
    CA: { name: 'Canada', taxLabel: 'GST/HST/PST', serviceLabel: 'Service Charge/Tip' },
    GB: { name: 'United Kingdom', taxLabel: 'VAT', serviceLabel: 'Service Charge (Optional Tip)' },
    AU: { name: 'Australia', taxLabel: 'GST', serviceLabel: 'N/A (Tipping optional)' },
    NZ: { name: 'New Zealand', taxLabel: 'GST', serviceLabel: 'N/A (Tipping optional)' },
    IE: { name: 'Ireland', taxLabel: 'VAT', serviceLabel: 'Service Charge (Optional Tip)' },
    DE: { name: 'Germany', taxLabel: 'MwSt. (USt.)', serviceLabel: 'Bedienungsgeld (Often Incl.)' },
    FR: { name: 'France', taxLabel: 'TVA', serviceLabel: 'Service Compris (Tip for extra)' },
    ES: { name: 'Spain', taxLabel: 'IVA', serviceLabel: 'Servicio (Propina optional)' },
    IT: { name: 'Italy', taxLabel: 'IVA', serviceLabel: 'Servizio/Coperto' },
    JP: { name: 'Japan', taxLabel: '消費税 (Shōhizei)', serviceLabel: 'サービス料 (No Tipping Culture)' },
    CN: { name: 'China', taxLabel: '增值税 (Zēngzhíshuì)', serviceLabel: '服务费 (Tipping uncommon)' },
    IN: { name: 'India', taxLabel: 'GST', serviceLabel: 'Service Charge (Sometimes, Tip optional)' },
    BR: { name: 'Brazil', taxLabel: 'ICMS/ISS', serviceLabel: 'Serviço (10% common)' },
    ZA: { name: 'South Africa', taxLabel: 'VAT', serviceLabel: 'Tip (10-15% expected)' },
    SG: { name: 'Singapore', taxLabel: 'GST', serviceLabel: 'Service Charge (No Tip needed)' },
    HK: { name: 'Hong Kong', taxLabel: 'N/A', serviceLabel: 'Service Charge (10% common)' },
    AE: { name: 'UAE', taxLabel: 'VAT', serviceLabel: 'Service Charge/Tip' },
    SA: { name: 'Saudi Arabia', taxLabel: 'VAT', serviceLabel: 'Service Charge/Tip' },
    RU: { name: 'Russia', taxLabel: 'НДС (NDS)', serviceLabel: 'Обслуживание/Чаевые' },
    MX: { name: 'Mexico', taxLabel: 'IVA', serviceLabel: 'Propina (10-15% common)' },
    AR: { name: 'Argentina', taxLabel: 'IVA', serviceLabel: 'Servicio/Propina (Cubierto common)' },
    SE: { name: 'Sweden', taxLabel: 'Moms', serviceLabel: 'Service (Included, Tip optional)' },
    NO: { name: 'Norway', taxLabel: 'MVA', serviceLabel: 'Service (Included, Tip optional)' },
    DK: { name: 'Denmark', taxLabel: 'Moms', serviceLabel: 'Service (Included, Tip optional)' },
    FI: { name: 'Finland', taxLabel: 'ALV', serviceLabel: 'Palvelumaksu (Included, Tip optional)' },
    NL: { name: 'Netherlands', taxLabel: 'BTW', serviceLabel: 'Bediening (Included, Tip optional)' },
    BE: { name: 'Belgium', taxLabel: 'TVA/BTW', serviceLabel: 'Service (Included, Tip optional)' },
    CH: { name: 'Switzerland', taxLabel: 'MwSt./TVA/IVA', serviceLabel: 'Service (Included, Tip optional)' },
    AT: { name: 'Austria', taxLabel: 'USt.', serviceLabel: 'Bedienung (Included, Tip customary)' },
    PT: { name: 'Portugal', taxLabel: 'IVA', serviceLabel: 'Serviço (Taxa de Serviço)/Gorgeta' },
    GR: { name: 'Greece', taxLabel: 'ΦΠΑ (FPA)', serviceLabel: 'Εξυπηρέτηση (Tip customary)' },
    PL: { name: 'Poland', taxLabel: 'VAT', serviceLabel: 'Serwis (Often added)/Napiwek' },
    CZ: { name: 'Czech Republic', taxLabel: 'DPH', serviceLabel: 'Obsluha (Tip customary)' },
    HU: { name: 'Hungary', taxLabel: 'ÁFA', serviceLabel: 'Felszolgálási díj (Often added)' },
    RO: { name: 'Romania', taxLabel: 'TVA', serviceLabel: 'Serviciu/Bacșiș' },
    TR: { name: 'Turkey', taxLabel: 'KDV', serviceLabel: 'Servis ücreti/Bahşiş' },
    KR: { name: 'South Korea', taxLabel: '부가세 (Bugase)', serviceLabel: 'N/A (No Tipping Culture)' },
    TH: { name: 'Thailand', taxLabel: 'VAT', serviceLabel: 'Service Charge (Sometimes, Tip optional)' },
    MY: { name: 'Malaysia', taxLabel: 'SST', serviceLabel: 'Service Charge (Often 10%)' },
    ID: { name: 'Indonesia', taxLabel: 'PPN', serviceLabel: 'Biaya Layanan (Service Charge)' },
    PH: { name: 'Philippines', taxLabel: 'VAT', serviceLabel: 'Service Charge (Often 10%)' },
    VN: { name: 'Vietnam', taxLabel: 'VAT (GTGT)', serviceLabel: 'Phí Dịch Vụ (Service Charge)' },
    EG: { name: 'Egypt', taxLabel: 'ضريبة القيمة المضافة', serviceLabel: 'رسوم الخدمة (Baksheesh expected)' },
    // Add more as needed. Consider creating a more generic "Other" or allowing custom labels.
    OTHER: { name: 'Other/Custom', taxLabel: 'Tax/VAT/GST', serviceLabel: 'Service/Tip' },
};

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

const ConfirmationDialog = ({ open, onClose, onConfirm, title, message }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-gray-600/75 dark:bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 z-[200]">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-md w-full p-6">
        <h3 className="text-xl font-semibold text-gray-800 dark:text-white mb-4">{title}</h3>
        <p className="text-sm text-gray-600 dark:text-gray-300 mb-6">{message}</p>
        <div className="flex justify-end space-x-3">
          <button onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg shadow-sm">Cancel</button>
          <button onClick={onConfirm} className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-lg shadow-sm">Leave</button>
        </div>
      </div>
    </div>
  );
};


function App() {
  const [darkMode, setDarkMode] = useState(() => {
    const savedMode = localStorage.getItem('darkMode');
    return savedMode === 'true';
  });

  const [currentCurrency, setCurrentCurrency] = useState(() => {
    return localStorage.getItem('appCurrency') || 'USD'; // Default to USD
  });
  const [currentRegion, setCurrentRegion] = useState(() => {
    return localStorage.getItem('appRegion') || 'US'; // Default to US
  });

  const [isTabDividerDirty, setIsTabDividerDirty] = useState(false);
  const [showLeaveConfirm, setShowLeaveConfirm] = useState(false);
  const [navigationAttempt, setNavigationAttempt] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const previousLocationRef = useRef(location);

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    localStorage.setItem('darkMode', darkMode.toString());
  }, [darkMode]);

  useEffect(() => {
    localStorage.setItem('appCurrency', currentCurrency);
  }, [currentCurrency]);

  useEffect(() => {
    localStorage.setItem('appRegion', currentRegion);
  }, [currentRegion]);

  const toggleDarkMode = useCallback(() => setDarkMode(prevMode => !prevMode), []);
  
  // Modified handlers to accept value directly for programmatic changes if needed
  const handleCurrencyChange = useCallback((newCurrency) => {
    setCurrentCurrency(newCurrency);
  }, []);
  const handleRegionChange = useCallback((newRegion) => {
    setCurrentRegion(newRegion);
  }, []);

  const handleSetTabDividerDirty = useCallback((dirty) => {
    setIsTabDividerDirty(dirty);
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isTabDividerDirty) {
        event.preventDefault();
        event.returnValue = 'You have unsaved changes. Are you sure you want to leave?';
        return event.returnValue;
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isTabDividerDirty]);

  useEffect(() => {
    const currentPath = location.pathname;
    const previousPath = previousLocationRef.current.pathname;

    if (previousPath === "/" && currentPath !== "/" && isTabDividerDirty) {
      setNavigationAttempt({
        action: 'PUSH', // Simplified
        location: location
      });
      setShowLeaveConfirm(true);
      navigate(previousPath, { replace: true });
    }
    previousLocationRef.current = location;
  }, [location, navigate, isTabDividerDirty]);

  const attemptNavigationForLinks = useCallback((pathToGo) => {
    const currentPath = location.pathname;
    if (currentPath === "/" && pathToGo !== "/" && isTabDividerDirty) {
      setNavigationAttempt({ action: 'PUSH', location: { pathname: pathToGo } });
      setShowLeaveConfirm(true);
    } else {
      navigate(pathToGo);
    }
  }, [isTabDividerDirty, location.pathname, navigate]);

  const handleConfirmLeave = useCallback(() => {
    if (navigationAttempt && navigationAttempt.location) {
      setIsTabDividerDirty(false);
      setShowLeaveConfirm(false);
      navigate(
        navigationAttempt.location.pathname + (navigationAttempt.location.search || '') + (navigationAttempt.location.hash || ''),
        { replace: true }
      );
      setNavigationAttempt(null);
    } else {
      setShowLeaveConfirm(false);
      setNavigationAttempt(null);
    }
  }, [navigationAttempt, navigate]);

  const handleCancelLeave = useCallback(() => {
    setShowLeaveConfirm(false);
    setNavigationAttempt(null);
  }, []);

  return (
    <>
      <ScrollToTop />
      <div className={`flex flex-col min-h-screen ${darkMode ? 'dark' : ''} bg-gray-100 dark:bg-gray-950 text-gray-900 dark:text-white`}>
        <Header
          darkMode={darkMode} toggleDarkMode={toggleDarkMode}
          currentCurrency={currentCurrency} handleCurrencyChange={handleCurrencyChange}
          currentRegion={currentRegion} handleRegionChange={handleRegionChange}
          currencies={CURRENCIES} regions={REGIONS}
          onNavigate={attemptNavigationForLinks}
        />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={
              <TabDividerApp
                initialDarkMode={darkMode}
                appCurrency={currentCurrency}
                appRegion={currentRegion}
                currenciesConfig={CURRENCIES} // Pass the comprehensive CURRENCIES config
                regionsConfig={REGIONS}     // Pass the comprehensive REGIONS config
                onSetDirty={handleSetTabDividerDirty}
              />}
            />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/gdpr-compliance" element={<GDPRCompliance />} />
            <Route path="/FAQ" element={<FAQ />} />
            <Route
              path="/blog" // Using lowercase for consistency
              element={<BlogListingPage onNavigate={attemptNavigationForLinks} />}
            />
            <Route
              path="/blog/:slug"
              element={<BlogPostPage onNavigate={attemptNavigationForLinks} />}
            />
          </Routes>
        </main>
        <Footer
          onNavigate={attemptNavigationForLinks}
        />
        <ConfirmationDialog
          open={showLeaveConfirm}
          onClose={handleCancelLeave}
          onConfirm={handleConfirmLeave}
          title="Unsaved Changes"
          message="You have unsaved changes. Are you sure you want to leave? Your progress will be lost."
        />
      </div>
    </>
  );
}

export default App;